import PropTypes from "prop-types";
import ProductCard from "../../components/ProductCard/ProductCard";

const LightRental = ({
  devices,
  addToCart,
  removeFromCart,
  cartItems,
  selectedQuantities,
}) => {
  // Jos laitelista on tyhjä, näytetään viesti
  if (!devices || devices.length === 0) {
    return (
      <div className="text-center py-10">
        <h2 className="text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-center font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">Esitystekniikka</h2>
        <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light pb-10">
          Ladataan esitystekniikkalaitteita..
        </p>
      </div>
    );
  }

  return (
    <div className="dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 pb-10 py-5 p-5 max-w-7xl mx-auto mt-10 rounded-3xl">
      <div className="flex flex-row items-center flex-wrap">
        <h2 className="text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">
          Esitystekniikka
        </h2>
      </div>

      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light pb-10">
        Äänentoisto on vasta alkua! Nosta tapahtumasi seuraavalle tasolle
        upeilla valaistus- ja savutehosteilla. Oikeanlainen esitystekniikka
        luo unohtumattoman tunnelman ja tekee vaikutuksen yleisöösi.
      </p>

      <div className="grid grid-cols-1 xxxsm:grid-cols-1 xxsm:grid-cols-1 s24:grid-cols-1 xsm:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 mdd:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
        {devices.map((item) => (
          <ProductCard
            key={item.id}
            item={item}
            isBooked={item.isBooked}
            isDisabled={item.isBooked || parseInt(item.available, 10) === 0}
            addToCart={addToCart}
            removeFromCart={removeFromCart}
            cartItems={cartItems}
            selectedQuantities={selectedQuantities}
          />
        ))}
      </div>
    </div>
  );
};

LightRental.propTypes = {
  devices: PropTypes.array.isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  cartItems: PropTypes.array.isRequired,
  selectedQuantities: PropTypes.object.isRequired,
};

export default LightRental;